module.exports = __webpack_public_path__ + "static/media/01.ed2d9406.png";